import { z } from "zod"
import Region from "../../domain/Region.js"

/**
 * @description
 *	The schema of {@link AWSRegion} type.
 */
export const AWSRegionSchema = z.enum(Region)

/**
 * @description
 *	An AWS region.
 */
export type AWSRegion = z.infer<typeof AWSRegionSchema>
